import { createFileRoute } from "@tanstack/react-router"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { Support } from "modules/support/components"
import { SupportFilterBy, SupportSortBy } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SupportTabSchema = z.enum([
  "tickets",
  "questions",
  "newQuestions",
  "actionRequests",
  "issues",
])

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.extend(SupportSortBy.shape.sortBy.unwrap().shape)
  .extend(SupportFilterBy.shape)
  .extend(SearchQuerySchema.shape)
  .extend(z.object({ supportTab: SupportTabSchema.optional().default("tickets") }).shape)

export const Route = createFileRoute("/_base/_auth/support/list")({
  component: Support,
  validateSearch: SearchSchema,
})
